import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

class BrochureConfirmation extends Component {

	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.props.state.list && !this.props.state.list.availability) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}

    render() {
        return (
            <div>
				<h1>{this.props.params.what === 'create'?"Create":"Update"} Brochure</h1>
				<p className="importantText bold">Your brochure has been {this.props.params.what === 'create'?"saved":"updated"} under the following name:</p>
                <p className="bold">{this.props.state.brochure.payload.brochure.brochureName}</p>
				<p>To access your brochure, go to <b>Saved Brochures</b> under the <b>Tools</b> menu.</p>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {state};
};

BrochureConfirmation = connect(mapStateToProps)(BrochureConfirmation);
export default BrochureConfirmation;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/confirmation.js